module.exports = __webpack_public_path__ + "static/media/kultur-und-kreativpiloten.065eeb3e.png";